import React, { useState } from "react";
import MainComponent from "../../../components/ui_comps/MainComponent";
import {
  primaryColor,
  sidebarFontColor,
} from "../../../../utility/constants/colorManager";
import SingleUpload from "./single_upload/SingleUpload";
import BulkUpload from "./bulk_upload/BulkUpload";

const CustomerTabComponent = ({ tabs, currentTab, onChange }) => {
  return (
    <div style={{ width: "100%", display: "flex", padding: "20px", gap: 40 }}>
      {tabs.map((tab, index) => {
        return (
          <div
            style={{
              cursor: "pointer",
            }}
            onClick={() => onChange(tab.key)}
          >
            <p
              style={{
                color: currentTab === tab.key ? primaryColor : sidebarFontColor,
                fontWeight: "500",
              }}
            >
              {tab.name}
            </p>

            {currentTab === tab.key && (
              <div
                style={{
                  border: `1px solid ${primaryColor}`,
                  marginTop: "5px",
                  width: "80%",
                  borderRadius: "5px",
                  opacity: 0.9,
                }}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};

const CustomerCenterIndex = () => {
  const [currentTab, setCurrentTab] = useState(1);

  const tabs = [
    // { name: "Single Upload", key: 0 },
    { name: "Bulk Upload", key: 1 },
  ];
  return (
    <div
      style={{
        width: "100%",
        overflow: "auto",
        boxSizing: "border-box",
        backgroundColor: "white",
      }}
    >
      <MainComponent
        notificationRequired={false}
        onClickFilter={() => { }}
        onClickFilterCall={() => { }}
        headerTitle="Customer Center"
        filterRequired={false}
      />

      <div
        style={{
          padding: "20px",
          width: "100%",
          borderBottom: "1px solid #F3F3F3",
        }}
      >
        {/* <p style={{ color: "#1E2234", fontWeight: "500", fontSize: "16px" }}>
          Upi Collection and Qr
        </p> */}
      </div>

      <CustomerTabComponent
        tabs={tabs}
        currentTab={currentTab}
        onChange={(data) => setCurrentTab(data)}
      />
      {/* {currentTab === 1 ? <SingleUpload /> : <BulkUpload />} */}
      {currentTab === 1 ? <BulkUpload /> : null}
    </div>
  );
};

export default CustomerCenterIndex;
